(function ManagerChckerForm($, HE)
{
	"use strict";

	var form = {
		name: 'Checker',
	};

	$(document).ready(function documentReady()
	{
		HE.Form.registerForm(form);

		$('.clear-button-link').on('click', function _clearField() {
			$('#checker-hotel').val('');
			$('#checker-giata_id').val('');

			$('.clear-button').addClass('d-none');
		});
	});

	form.load = function load($form)
	{
		HE.Typeahead(
			'#checker-hotel',
			'/Main/hotelSearch',
			function _selectHotel(item, $self, typeahead) {
				$('#checker-giata_id').val(item.id);
				typeahead.setHiddenValue(item.id);

				$('.clear-button').removeClass('d-none');
			}
		);

		$('.output').on('click', '.view-response-link', function _viewResponse(e) {
			var json   = jsonToHtml($(this).data('json')),
				$modal = $(".modal");

			e.preventDefault();

			if (json === '<ul></ul>') {
				json = '<h4>No data returned</h4>';
			}

			$('.modal-dialog').addClass('mw-100 w-75');
			$modal.find('.modal-title').text('Response');
			$modal.find('.modal-body').html('<pre style="background-color: #EEE">' + json + '</pre>');
			$modal.modal('show');

		});

	};

	form.success = function success(response)
	{
		var checkin_date,
			checkout_date,
			$giata_id;

		if (!HE.Form.hasError(response)) {
			$giata_id = $('#checker-giata_id').val();
			checkin_date     = reformatDate($('#checker-checkin_checkout').val(), 'start');
			checkout_date	= reformatDate($('#checker-checkin_checkout').val(), 'end');

			$('.output').removeClass('d-none');

			HE.Ajax.get('/Main/hotelGiatas/' + $giata_id).then(function _getGiatas(results_html) {
				$('.giatas-content').html(results_html);

				checkRates(checkin_date, checkout_date);
			}).catch(function _giatasError(data) {
				HE.StatusMessage('error', 'Cant do it');
			});
		}

		return false;
	};

	function checkRates(checkin_date, checkout_date) {
		$('.rates').each(function _eachRates() {
			var $obj        = $(this),
				property_id = $(this).data('property-id'),
				provider_id = $(this).data('provider-id'),
				giata_id    = $(this).data('giata-id'),
				rate_url    = '/Main/checkerRates/' + property_id + '/' + provider_id + '/' + checkin_date + '/' + checkout_date + '/' + giata_id;

			if ($(this).data('property-id') === '') {
				$(this).html('');
			} else {
				HE.Ajax.get(rate_url).then(function _getGiatas(result) {
					$obj.html(result);
				}).catch(function _giatasError(data) {
					HE.StatusMessage('error', 'Cant do it');
				});
			}
		});
	}

	function reformatDate(date, datetype)
	{
		let dateRange          = date;
		let dates              = dateRange.split(" - ");

		let startDate          = new Date(dates[0]);
		let endDate            = new Date(dates[1]);

		let startYear          = startDate.getFullYear();
		let startMonth         = (startDate.getMonth() + 1).toString().padStart(2, '0'); // JavaScript months are 0-based
		let startDay           = startDate.getDate().toString().padStart(2, '0');

		let endYear            = endDate.getFullYear();
		let endMonth           = (endDate.getMonth() + 1).toString().padStart(2, '0'); // JavaScript months are 0-based
		let endDay             = endDate.getDate().toString().padStart(2, '0');

		let formattedStartDate = `${startYear}-${startMonth}-${startDay}`;
		let formattedEndDate   = `${endYear}-${endMonth}-${endDay}`;

		if (datetype === 'start') {
			return formattedStartDate;
		} else if (datetype === 'end') {
			return formattedEndDate;
		}
	}

	function jsonToHtml(json) {
		let html = '<ul>';
		for (let key in json) {
			if (typeof json[key] === 'object' && json[key] !== null) {
				html += '<li>' + key + jsonToHtml(json[key]) + '</li>';
			} else {
				html += '<li>' + key + ': ' + json[key] + '</li>';
			}
		}
		html += '</ul>';
		return html;
	}
}(jQuery, window.HE || {}));
